/* eslint-disable */

import React from "react";

function Header() {
  return (
    <header className="container user-avatar">
      <h1>404: page not found</h1>
    </header>
  );
}
export default Header;